module.exports = __webpack_public_path__ + "static/img/diamond.501e0457.svg";